


















import { defineComponent, onMounted, ref, watch } from '@vue/composition-api'

export default defineComponent({
  setup(props) {
    const dialogVisible = ref(false)
    const tableData = [
      {
        device: 'An Android device (preferably with a biometric sensor)',
        browser: 'Google Chrome 67 or higher',
      },
      {
        device: 'An Android device (preferably with a biometric sensor)',
        browser: 'The official browser included in Android 9+',
      },
      {
        device: 'An iPhone or iPad running iOS 14 or later with Touch ID or Face ID',
        browser: 'Safari 14 or higher',
      },
      {
        device: 'An iPhone or iPad running iOS 14 or later with Touch ID or Face ID',
        browser: 'Google Chrome 67 or higher',
      },
      {
        device: 'A MacBook Pro or Air with macOS Big Sur or later and Touch ID',
        browser: 'Safari 14 or higher',
      },
      {
        device: 'A MacBook Pro or Air with macOS Big Sur or later and Touch ID',
        browser: 'Google Chrome 67 or higher',
      },
      {
        device: 'Windows 10 19H1 or later with Windows Hello set up',
        browser: 'Microsoft Edge 85 or higher',
      },
      {
        device: 'Windows 10 19H1 or later with Windows Hello set up',
        browser: 'Google Chrome 67 or higher',
      },
    ]

    const objectSpanMethod = ({ row, column, rowIndex, columnIndex }: any) => {
      if (columnIndex === 0) {
        if (rowIndex % 2 === 0) {
          return {
            rowspan: 2,
            colspan: 1,
          }
        } else {
          return {
            rowspan: 0,
            colspan: 0,
          }
        }
      }
    }

    const showDialog = () => {
      dialogVisible.value = true
    }

    const closeDialog = () => {
      dialogVisible.value = false
    }

    return { dialogVisible, showDialog, closeDialog, tableData, objectSpanMethod }
  },
})
